import { serverHttp } from "@/plugins/axios";

export const login = function(username: string, password: string) {
    return serverHttp.post("/api/login", {
        username: username,
        password: password
    });
};

export const identityLogin = function(ticket: string, service: string) {
    return serverHttp.post("/api/identity-login", {
        ticket: ticket,
        service: service
    });
};
